import React, { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { drw, errText } from "./api";
import { PurposeChip } from "./FieldShopLinks";
import FieldShopAssign from "./FieldShopAssign";

/** DRW-6 — the project's field shop sets: scope, purpose, published state, room assignment.
 *  Separate from the architectural index: these never enter revision matching or takeoffs. */
export default function FieldShopSets({ projectId, activeId, onOpenSheet, canWrite, refreshKey }) {
  const [sets, setSets] = useState(null);
  const [assign, setAssign] = useState(null);
  const load = useCallback(() => drw.get(`/projects/${projectId}/field-shop/sets`).then(({ data }) => setSets(data.sets)).catch(() => setSets([])), [projectId]);
  useEffect(() => { load(); }, [load, refreshKey]);
  if (!sets?.length) return null;
  return (
    <div className="rounded-xl border border-neutral-200 bg-white p-2 space-y-2" data-testid="field-shop-sets">
      <div className="text-xs font-semibold text-neutral-700">Field shop drawings <span className="font-normal text-neutral-500">— fabrication / installation sheets by room · not submittals</span></div>
      {sets.map((s) => (
        <div key={s.id} className="border rounded-lg p-2 space-y-1" data-testid={`shop-set-${s.id}`} data-published={s.published ? "1" : "0"}>
          <div className="flex items-center gap-2 flex-wrap text-xs">
            <PurposeChip purpose={s.purpose} scopes={s.scopes} size="sm" testId={`shop-set-purpose-${s.id}`} />
            <span className="font-semibold">{s.revision_label || s.file_name}</span>
            <span className="text-neutral-500">{s.sheets.length} sheet(s)</span>
            {s.published ? <span className="px-1.5 rounded bg-emerald-100 text-emerald-800">published</span> : <span className="px-1.5 rounded bg-red-100 text-red-800" data-testid={`shop-set-unpublished-${s.id}`}>not published{s.unassigned ? ` · ${s.unassigned} unassigned` : ""}</span>}
            {canWrite && <button type="button" onClick={() => setAssign(s)} className="ml-auto px-2 min-h-9 rounded border" data-testid={`shop-set-manage-${s.id}`}>Rooms / purpose</button>}
            {canWrite && s.published && <button type="button" onClick={() => drw.post(`/field-shop/sets/${s.id}/unpublish`, {}, { _noQueue: true }).then(() => { toast.success("Unpublished"); load(); }).catch((e) => toast.error(errText(e)))} className="px-2 min-h-9 rounded border text-neutral-600" data-testid={`shop-set-unpublish-${s.id}`}>Unpublish</button>}
          </div>
          <div className="flex flex-wrap gap-1">
            {s.sheets.map((sh) => (
              <button key={sh.id} type="button" onClick={() => onOpenSheet(sh.id)} className={`text-left text-[11px] px-2 min-h-9 rounded border ${activeId === sh.id ? "border-orange-400 bg-orange-50" : "bg-white"}`} data-testid={`shop-sheet-open-${sh.id}`}>
                <span className="font-mono font-semibold">{sh.sheet_number}</span> <span className="text-neutral-500">{(sh.room_refs || []).map((r) => r.room_number).join(", ") || "no room"}</span>
              </button>
            ))}
          </div>
        </div>
      ))}
      {assign && <FieldShopAssign set={assign} onChanged={() => load()} onClose={() => { setAssign(null); load(); }} />}
    </div>
  );
}
